import React, { useState } from "react";
import { Download } from "lucide-react";
import { downloadBullseyeAwardsCsv } from "../../lib/bullseyeAwardsCsv";
import "./BullseyeAwardsCsvExport.css";

export default function BullseyeAwardsCsvExport({ matchName, rows, disabled }) {
  const [error, setError] = useState("");

  const download = () => {
    if (disabled) return;
    setError("");
    try { downloadBullseyeAwardsCsv({ matchName, rows, metric: "scoreAndX" }); }
    catch (failure) { setError(failure.message || "The worksheet could not be downloaded. Please try again."); }
  };

  return <div className="bullseye-awards-export">
    <p className="match-download-summary">All competitors · All score sections · Score-X (198-5X)</p>
    <button type="button" className="registration-auth-secondary leaderboard-inline-link bullseye-awards-export-trigger"
      disabled={disabled} onClick={download}>
      <Download size={17} aria-hidden="true" />Download Scores CSV
    </button>
    {error && <p className="bullseye-bulletin-export-error" role="alert">{error}</p>}
  </div>;
}
